import { Inject, Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Auth0Group, SortFilterInterface} from '../..';

export interface GroupsAPI {
  items: Auth0Group[];
  total_count: number;
}
@Injectable({
  providedIn: 'root'
})
export class Auth0PermissionsService {

  constructor( @Inject(ConfigService) private config, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'PADM').url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }
  private URL;
  headers: HttpHeaders;

  private static handleHTTPError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
          `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }

  getGroups(pageIndex: number, pageSize: number, sortActive: string, sort: string, sortFilter: SortFilterInterface): Observable<GroupsAPI> {

    const headers = this.headers;
    if ((sortActive === '') || (sort === '')) {
      sortActive = '0';
      sort = 'asc';
    }
    return this.httpClient.post<GroupsAPI>(
        `${this.URL}/auth0/permissions/groups/${pageIndex}/${pageSize}/${sortActive}/${sort}`,sortFilter, {headers}).pipe(
        catchError(Auth0PermissionsService.handleHTTPError)
    );

  }

}
